<script>
    import { onMount } from "svelte";
    import {Line} from "svelte-chartjs";
    import {Chart as ChartJS,Title,Tooltip,Legend,LineElement,LinearScale,PointElement,CategoryScale,} from 'chart.js';
    ChartJS.register(Title,Tooltip,Legend,LineElement,LinearScale,PointElement,CategoryScale);

    let totalcount = 0;
    let infotext = "";
    let filterdevs = [];

    let dlg_rtdata_title = "";
    let dlg_rtdata_devcode = "";
    let dlg_rtdata_display = "";

    let dlg_curve_title = "";
    let dlg_curve_devcode = "";
    let dataobj = {};
    let optnobj = {};

    // 提示框配置
    toastr.options = {
        positionClass: "toast-top-center",
    };

    // 加载事件函数
    onMount(() => {
    });

    function GetOfflineDevices() {
        let tmp_url = "/rtapi/findoffline";
        jQuery.ajax({
            type: "get",
            url: tmp_url,
            success: function (response) {
                if (response.code == 200) {
                    if (Array.isArray(response.result)) {
                        filterdevs = response.result;
                        totalcount = filterdevs.length;
                        infotext = "设备故障，"
                    } else {
                        toastr.error("离线设备数据格式错误");
                    }
                } else {
                    toastr.error("获取离线设备数据失败");
                }
            },
            error: function (err) {
                toastr.error("获取离线设备数据错误" + err);
            },
        });
    }

    function GetLPosErrDevices() {
        let tmp_url = "/rtapi/findlposerr";
        let devs = [];
        jQuery.ajax({
            type: "post",
            url: tmp_url,
            data: JSON.stringify(devs),
            success: function (response) {
                if (response.code == 200) {
                    if (Array.isArray(response.result)) {
                        filterdevs = response.result;
                        totalcount = filterdevs.length;
                        infotext = "液位异常，"
                    } else {
                        toastr.error("液位异常数据格式错误");
                    }
                } else {
                    toastr.error("获取液位异常数据失败");
                }
            },
            error: function (err) {
                toastr.error("获取液位异常数据错误:" + err);
            }
        });
    }

    function GetLowPowerDevices() {
        let tmp_url = "/rtapi/findlowpower";
        jQuery.ajax({
            type: "get",
            url: tmp_url,
            success: function (response) {
                if (response.code == 200) {
                    if (Array.isArray(response.result)) {
                        filterdevs = response.result;
                        totalcount = filterdevs.length;
                        infotext = "电量异常，"
                    } else {
                        toastr.error("电量异常数据格式错误");
                    }
                } else {
                    toastr.error("获取电量异常数据失败");
                }
            },
            error: function (err) {
                toastr.error("获取电量异常数据错误" + err);
            },
        });
    }

    function GetWakeupErrDevices() {
        let tmp_url = "/rtapi/findwakeuperr";
        jQuery.ajax({
            type: "get",
            url: tmp_url,
            success: function (response) {
                if (response.code == 200) {
                    if (Array.isArray(response.result)) {
                        filterdevs = response.result;
                        totalcount = filterdevs.length;
                        infotext = "唤醒参数异常，"
                    } else {
                        toastr.error("唤醒参数异常数据格式错误");
                    }
                } else {
                    toastr.error("获取唤醒参数异常数据失败");
                }
            },
            error: function (err) {
                toastr.error("获取唤醒参数异常数据错误" + err);
            },
        });
    }

    function showRtdata(code) {
        dlg_rtdata_devcode = code;
        dlg_rtdata_title = "设备" + dlg_rtdata_devcode + "的实时数据";
        let tmpUrl1 = "/rtapi/getdevrtdatas?code=" + code;
        let tmpUrl2 = "/rtapi/getdevregdatas?code=" + code;
        // 实时数据
        jQuery.ajax({
            type: "get",
            url: tmpUrl1,
            success: function (response) {
                if (response.code == 200) {
                    let robj = response.result;
                    //console.log(robj);
                    let sHtml = "";
                    if (robj.devcode == undefined) {
                        sHtml = "<li>找不到数据</li>";
                    } else {
                        sHtml += "<li>设备号：" + robj.devcode + "</li>";
                        sHtml += "<li>更新时间：" + robj.lastupdate + "</li>";
                        if (robj.props != undefined) {
                            for (let i=0;i<robj.props.length;i++)
                            {
                                sHtml +=  ("<li>" + robj.props[i].propertyname + "：" + robj.props[i].rtval + "</li>")
                            }
                        }
                        // 注册数据
                        jQuery.ajax({
                            type: "get",
                            url: tmpUrl2,
                            success: function (response2) {
                                let robj2 = response2.result;
                                //console.log(robj2);
                                if (robj2.props != undefined) {
                                    for (let i=0;i<robj2.props.length;i++)
                                    {
                                        sHtml +=  ("<li>" + robj2.props[i].propertyname + "：" + robj2.props[i].rtval + "</li>")
                                        dlg_rtdata_display = sHtml
                                    }
                                }
                            }
                        });
                    }
                    dlg_rtdata_display = sHtml
                    jQuery("#rtdata-modal").modal("show");
                } else {
                    toastr.error("调取实时数据错误:");
                }
            },
            error: function (err) {
                console.log(err);
                toastr.error("调取实时数据异常:");
            },
        });
    }

    function closeRtdata() {
        jQuery("#rtdata-modal").modal("hide");
    }

    function showCurve(code) {
        dlg_curve_devcode = code;
        dlg_curve_title = "设备" + dlg_curve_devcode + "的历史数据曲线图";
        loadCurveData("lpos");
        jQuery("#curve-modal").modal("show");        
    }

    function closeCurve() {
        jQuery("#curve-modal").modal("hide");
    }

    function fixMax(inmax) {
        let outMax = 1;
        if  (inmax < 5) {
            outMax = 5;
        } else if (inmax < 10) {
            outMax = 10;
        } else if (inmax < 20) {
            outMax = 20;
        } else if (inmax < 50) {
            outMax = 50;
        } else if (inmax < 100) {
            outMax = 100;
        } else if (inmax < 150) {
            outMax = 150;
        } else if (inmax < 200) {
            outMax = 200;
        } else if (inmax < 300) {
            outMax = 300;
        } else if (inmax < 500) {
            outMax = 500;
        } else if (inmax < 1000) {
            outMax = 1000;
        } else {
            outMax = 2000;
            // outMax = (Math.ceil(inmax / 10) + 5) * 10;
        }
        return outMax;
    }

    function loadCurveData(pcode) {
        let dtStart = new Date();
        dtStart = new Date(dtStart.setDate(dtStart.getDate()-30));
        let dtEnd = new Date();
        dtEnd = new Date(dtEnd.setDate(dtEnd.getDate()+1));
        let datax = [];
        let datay1 = [];
        let ymin = 0;
        let ymax = 100;
        let strStart = CommonLib.dtFormat("YYYY-mm-dd",dtStart);
        let strEnd = CommonLib.dtFormat("YYYY-mm-dd",dtEnd);
        let tmpUrl = "/dbapi/queryhistorydata?devid="+dlg_curve_devcode+"&property="+pcode+"&start="+strStart+"&end="+strEnd;
        // console.log(tmpUrl);
        jQuery.ajax({
            type: "get",
            url: tmpUrl,
            success: function (response) {
                if (response.code == 200) {
                    if (Array.isArray(response.result)) {
                        let hidatas = response.result;
                        //console.log(hidatas);
                        let tmpMax = 0;
                        for (let i=0;i<hidatas.length;i++) {
                            let tmp_date = new Date(hidatas[i].rdatatime);
                            let tmp_datestr = (tmp_date.getMonth() + 1).toString() + "-" + tmp_date.getDate().toString() + " " + tmp_date.getHours().toString();
                            datax.push(tmp_datestr);
                            if (tmpMax < hidatas[i].floatval) {
                                tmpMax = hidatas[i].floatval;
                            }
                            datay1.push(hidatas[i].floatval);
                        }
                        ymax = fixMax(tmpMax);
                        dataobj = {
                            labels: datax,
                            datasets: [
                                {
                                    label: pcode,
                                    backgroundColor: "rgb(255, 0, 0)",
                                    borderColor: "rgb(255, 0, 0)",
                                    data: datay1
                                }
                            ]
                        };
                        optnobj = {
                            scales: {
                                y: { min: ymin, max: ymax }
                            }
                        };
                    }
                } else {
                    toastr.error("调取历史数据错误:");
                }
            },
            error: function (err) {
                console.log(err);
                toastr.error("调取历史数据异常:");
            }
        })
    }
</script>

<!-- Content Wrapper. Contains page content -->
<div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1>异常发现</h1>
                </div>
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">&nbsp;</ol>
                </div>
            </div>
        </div>
    </section>
    <!-- Main content -->
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <!-- card -->
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">
                                <a href={"javascript:;"} on:click={GetOfflineDevices} class="operation_link">故障设备</a>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <a href={"javascript:;"} on:click={GetLPosErrDevices} class="operation_link">液位异常</a>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <a href={"javascript:;"} on:click={GetLowPowerDevices} class="operation_link">电量异常</a>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <a href={"javascript:;"} on:click={GetWakeupErrDevices} class="operation_link">唤醒参数异常</a>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </h3>
                        </div>
                        <div class="card-body">
                            <div class="row" style="height:50px">
                                <span>{infotext}符合条件的设备有 {totalcount} 台</span>
                            </div>
                            <div class="row" style="height:550px">
                                {#each filterdevs as dcode}
                                <div class="col-sm-3" style="display:inline-block">
                                    {dcode} &nbsp;&nbsp;&nbsp;&nbsp;
                                    <span class="operation_link" title="实时数据"
                                        on:click={() => showRtdata(dcode)}
                                        on:keyup={() => {}} 
                                        role="button" tabindex="0">
                                        <i class="bi bi-chat-dots" ></i>
                                    </span>
                                    &nbsp;&nbsp;
                                    <span class="operation_link" title="曲线图"
                                        on:click={() => showCurve(dcode)}
                                        on:keyup={() => {}} 
                                        role="button" tabindex="0">
                                    <i class="bi bi-graph-up"></i>
                                    </span>
                                </div>
                                {/each}
                            </div>
                        </div>
                    </div>
                    <!-- end of card -->
                </div>
            </div>
        </div>
    </section>
</div>
<!-- rtdata modal dialog -->
<div class="modal fade" id="rtdata-modal" data-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{dlg_rtdata_title}</h4>
                <button
                    type="button"
                    class="close"
                    on:click={closeRtdata}
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ul>{@html dlg_rtdata_display}</ul>
            </div>
            <div class="modal-footer justify-content-between">
                <button
                    type="button"
                    class="btn btn-default"
                    on:click={closeRtdata}
                >关闭</button>
            </div>
        </div>
    </div>
</div>
<!-- /rtdata modal dialog -->

<!-- curve modal dialog -->
<div class="modal fade" id="curve-modal" data-backdrop="static">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{dlg_curve_title}</h4>
                <button
                    type="button"
                    class="close"
                    on:click={closeCurve}
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>
                    设备代码：{dlg_curve_devcode}<br><br>
                    <span class="operation_link" on:click={() => loadCurveData("lpos")} on:keyup={() => {}} role="button" tabindex="0">液位曲线</span>
                    &nbsp;&nbsp;
                    <span class="operation_link" on:click={() => loadCurveData("ch4")} on:keyup={() => {}} role="button" tabindex="0">甲烷曲线</span>
                    &nbsp;&nbsp;
                    <span class="operation_link" on:click={() => loadCurveData("h2s")} on:keyup={() => {}} role="button" tabindex="0">硫化氢曲线</span>
                    &nbsp;&nbsp;
                    <span class="operation_link" on:click={() => loadCurveData("humidity")} on:keyup={() => {}} role="button" tabindex="0">湿度曲线</span>
                    &nbsp;&nbsp;
                    <span class="operation_link" on:click={() => loadCurveData("batvol")} on:keyup={() => {}} role="button" tabindex="0">电压曲线</span>
                </p>
                <Line data={dataobj} options={optnobj} style="height:400px; width:900px"/>
            </div>
            <div class="modal-footer justify-content-between">
                <button
                    type="button"
                    class="btn btn-default"
                    on:click={closeCurve}
                >关闭</button>
            </div>
        </div>
    </div>
</div>
<!-- /curve modal dialog -->

<style>
    .operation_link {
        color: #383838;
        cursor: pointer;
    }
    .operation_link:hover {
        color: blue;
    }
</style>
